export const TRANSLATIONS_NAMESPACE = 'form-viewer';
